import * as tracker from 'analytics/tracker';

import { Product } from 'app/api/products/types';

interface FormatProductAnalyticsDataProps {
  product: Product;
  isRank?: boolean;
}

export const formatProductAnalyticsData = ({
  product: { id, sku, variety, name, geneticType, company, color, rank, crop },
  isRank = false,
}: FormatProductAnalyticsDataProps): tracker.apiObject => {
  return {
    product_id: id,
    sku,
    variety,
    name: name ?? '',
    supplier_name: company.name,
    supplier_id: company.id,
    crop_id: crop,
    type: geneticType,
    continent: company.continent,
    color: color ?? '',
    ...(isRank && {
      rank: rank ?? '',
    }),
  };
};
